import { Customization, css } from '@eduvision/toolkit';
// import { default as CustomLoggedOutView } from '../views/LoggedOutView';

export const AdminContentDetailView: Customization['AdminContentDetailView'] = {
	hiddenFields: ['why', 'requirements']
};
